<header>
	<div
		[heading]="headingType()"
		class="heading-group"
		data-test-id="persuade-card-title"
		vc-heading
	>
		@if (cardUrl()) {
			<valk-core-smart-link
				[queryParams]="cardQueryParams()"
				[target]="cardTarget()"
				[url]="cardUrl()"
			>
				{{ title() }}
			</valk-core-smart-link>
		} @else {
			{{ title() }}
		}
	</div>
	@if (overline()) {
		<p
			class="heading-group-overline"
			data-test-id="persuade-card-overline"
			role="doc-subtitle"
		>
			{{ overline() }}
		</p>
	}
</header>
